<div class="sidebar__wrapper">
  <h3>Resumen</h3>
  @if(quoterState().quote.id && quoterState().user){
  <app-user-resume [user]="quoterState().user" />
  }
  
  <ng-container *ngComponentOutlet="dynamicRiskComponent()"></ng-container>

  <app-quoter-sidebar-coverage [coverage]="quoterState().selectedCoverage" [currency]="quoterState().currency"
    class="mb-5 mt-5" />

  @if(hasOptionalCoverages()){
  <app-quoter-sidebar-coverage [coverage]="quoterState().quote.additionalCoverage" [currency]="quoterState().currency"
    class="mb-5 mt-5" />

  }

  @if (quoterStateService.isPaymentStep()) {

    @if (isVehicle()) {
      <app-input-referral-code class="mb-5" [quoteId]="quoterState().quote.id ?? ''" (validReferrlCode)="setReferralCode($event)" />
    }

    @if (!quoterState().qr.token && !isVehicle()) {
      <activar-button text="Generar link de pago" color="primary" fill="out" expand="full" class="mb-2"
        (click)="generatePaymentLink()" [loading]="quoterState().generatePaymentLinkLoading" *showForChannels="['agents']"
        loadingText="Generando link..." />
    }

    <activar-button text="Emitir" color="primary" fill="solid" expand="full" (click)="emit()" class="mt-5"
      [loading]="quoterState().emitLoading" loadingText="Contratando..." />
  }
</div>